import { initStore } from '../../../common';
import { actions } from './actions';

export const customSettingsStore = (): void => {
	const initialState = {
		slice: 'SETTINGS',
		userId: '',
		username: '',
		languages: [],
		activeLanguage: [],
		currencies: [],
		activeCurrency: [],
		dateTimes: [],
		activeDateTime: [],
		isActive: true,
		lastActivity: '',
		defaults: {},
		errors: [],
		success: '',
	};

	initStore(actions, initialState);
};
